<template>
	<v-app :class="{ blur: showCredits, mobile: xs }" :theme="store.theme" style="max-width: 1920px; margin: 0 auto">
		<v-navigation-drawer v-if="!smAndDown" :order="2" width="200" floating location="left">
			<div class="h-100 d-flex align-center justify-center">
				<v-skeleton-loader v-if="false" height="600" width="160"></v-skeleton-loader>
				<a href="https://www.digitalocean.com/?refcode=fe4184318b19&utm_campaign=Referral_Invite&utm_medium=Referral_Program&utm_source=badge"><img src="https://web-platforms.sfo2.digitaloceanspaces.com/WWW/Badge%202.svg" style="width: 200px; height: 65px" alt="DigitalOcean Referral Badge" /></a>
			</div>
		</v-navigation-drawer>
		<sublet-header />
		<v-main>
			<router-view v-slot="{ Component }">
				<keep-alive>
					<component :is="Component" @update:theme="updateTheme" @error="errorHandler" @signup="signup = true" />
				</keep-alive>
			</router-view>
		</v-main>
		<v-navigation-drawer v-if="!smAndDown" :order="2" width="200" floating location="right">
			<div class="h-100 d-flex align-center justify-center">
				<v-skeleton-loader v-if="false" height="720" width="96%"></v-skeleton-loader>
				<a href="https://www.digitalocean.com/?refcode=fe4184318b19&utm_campaign=Referral_Invite&utm_medium=Referral_Program&utm_source=badge"><img src="https://web-platforms.sfo2.cdn.digitaloceanspaces.com/WWW/Badge%201.svg" style="width: 190px; height: 65px" alt="DigitalOcean Referral Badge" /></a>
			</div>
		</v-navigation-drawer>
		<nav-footer v-show="!xs || $route.path === '/'" />
		<v-snackbar text :timeout="-1" v-model="snackbar.active" style="opacity: 0.95" @click="snackbarCloseHandler" :color="store.theme === 'dark' ? 'grey-lighten-4' : 'grey-darken-4'">
			<v-row>
				<v-col cols="1" class="d-flex align-center justify-center py-0">
					<v-icon :icon="snackbar.icon" :color="snackbar.iconColor" :size="smAndDown ? 'x-small' : 'x-large'" class="ml-2" />
				</v-col>
				<v-col cols="10" class="d-flex align-center justify-center py-0">
					<span v-if="snackbar.message" v-html="snackbar.message"></span>
					<span v-else @click="reload" class="font-weight-light" v-bind:class="smAndDown ? 'caption' : ''" style="cursor: pointer">App update available.</span>
				</v-col>
				<v-col cols="1" class="d-flex align-center justify-center py-0">
					<v-btn variant="plain" :size="smAndDown ? 'x-small' : 'default'" @click="snackbarCloseHandler" icon="close" />
				</v-col>
			</v-row>
		</v-snackbar>
	</v-app>
</template>
<style>
html,
body {
	overscroll-behavior-x: none;
	background: white;
	font-size: 1.4rem !important;
}
@media (max-width: 600px) {
	body {
		font-size: 0.75rem !important;
	}
}
.saira-extra-condensed-thin {
	font-family: 'Saira Extra Condensed', sans-serif;
	font-weight: 100;
	font-style: normal;
}

.saira-extra-condensed-extralight {
	font-family: 'Saira Extra Condensed', sans-serif;
	font-weight: 200;
	font-style: normal;
}

.saira-extra-condensed-light {
	font-family: 'Saira Extra Condensed', sans-serif;
	font-weight: 300;
	font-style: normal;
}

.saira-extra-condensed-regular {
	font-family: 'Saira Extra Condensed', sans-serif;
	font-weight: 400;
	font-style: normal;
}

.saira-extra-condensed-medium {
	font-family: 'Saira Extra Condensed', sans-serif;
	font-weight: 500;
	font-style: normal;
}

.saira-extra-condensed-semibold {
	font-family: 'Saira Extra Condensed', sans-serif;
	font-weight: 600;
	font-style: normal;
}

.saira-extra-condensed-bold {
	font-family: 'Saira Extra Condensed', sans-serif;
	font-weight: 700;
	font-style: normal;
}

.saira-extra-condensed-extrabold {
	font-family: 'Saira Extra Condensed', sans-serif;
	font-weight: 800;
	font-style: normal;
}

.saira-extra-condensed-black {
	font-family: 'Saira Extra Condensed', sans-serif;
	font-weight: 900;
	font-style: normal;
}

.roboto-flex-light {
	font-family: 'Roboto Flex', sans-serif;
	font-optical-sizing: auto;
	font-weight: 300;
	font-style: normal;
	font-variation-settings: 'slnt' 0, 'wdth' 100, 'GRAD' 0, 'XOPQ' 96, 'XTRA' 468, 'YOPQ' 79, 'YTAS' 750, 'YTDE' -203, 'YTFI' 738, 'YTLC' 514, 'YTUC' 712;
}
.roboto-flex-medium {
	font-family: 'Roboto Flex', sans-serif;
	font-optical-sizing: auto;
	font-weight: 500;
	font-style: normal;
	font-variation-settings: 'slnt' 0, 'wdth' 100, 'GRAD' 0, 'XOPQ' 96, 'XTRA' 468, 'YOPQ' 79, 'YTAS' 750, 'YTDE' -203, 'YTFI' 738, 'YTLC' 514, 'YTUC' 712;
}
</style>
<script setup>
import { ref, getCurrentInstance, provide, inject, onBeforeMount } from 'vue'
import { useAppStore } from '@/store/app'
import { useDisplay } from 'vuetify/lib/framework.mjs'
import posthog from 'posthog-js'
import 'animate.css'

import NavFooter from './components/nav/NavFooter.vue'
import SubletHeader from '@/components/SubletHeader.vue'

const { MODE } = import.meta.env
if (MODE === 'production')
	posthog.init('phc_sYPTO5EGmHbaANPvkC49ilQqW1JXfW8bnSJQjoVX40M', {
		api_host: 'https://us.i.posthog.com',
		person_profiles: 'always',
	})

const clipboard = inject('clipboard')
const { $api } = getCurrentInstance().appContext.config.globalProperties
const { xs, smAndDown } = useDisplay()
const store = useAppStore()
const resetLocalStorage = ref(false)
const signup = ref(false)
const emit = defineEmits(['update:theme', 'error', 'signup'])
const error = ref(false)
const version = ref()
const snackbarDefault = {
	active: false,
	icon: 'info-circle',
	message: undefined,
}
const snackbar = ref({ ...snackbarDefault })
const lastBuild = ref()
const showCredits = ref(false)
const versionCheckIntervalId = ref()
const buildInfo = ref()

function errorHandler(errorMessage) {
	error.value = true
	snackbar.value = {
		active: true,
		icon: 'error',
		iconColor: 'red',
		message: errorMessage,
	}
}
function snackbarCloseHandler() {
	snackbar.value.active = false
	setTimeout(() => {
		snackbar.value = { ...snackbarDefault }
		if (error.value) {
			error.value = false
		}
	}, 500)
}
function reload() {
	const url = new URL(window.location.href)
	url.searchParams.set('cache', Date.now())
	window.location.href = url.toString()
}
async function checkVersion() {
	buildInfo.value = await $api.buildInfo()

	if (!buildInfo.value?.build_date) {
		return
	}
	version.value = buildInfo.value.commit_sha
	if (lastBuild.value && lastBuild.value?.build_date !== buildInfo.value.build_date) {
		snackbar.value.active = true
		// TODO: put some extra check here...
		resetLocalStorage.value = true
	} else {
		lastBuild.value = buildInfo.value
	}
}
function cacheIsOld(timestamp = Date.now(), maxAge = store.apiCalls.maxAge) {
	const expires = timestamp + maxAge
	const isOld = !timestamp || Date.now() > expires

	const red = '\x1b[31m'
	const green = '\x1b[32m'
	const reset = '\x1b[0m'
	console.log(`cache (${isOld ? `${red}EXPIRED${reset}` : `${green}valid${reset}`}): timestamp:${new Date(timestamp).toLocaleString()}, expires: ${new Date(expires).toLocaleString()} (${(expires - Date.now()) / 1000}) secs`)
	return isOld
}
async function hashString(message, algorithm = 'SHA-1') {
	const encoder = new TextEncoder()
	const data = encoder.encode(message)
	const hashBuffer = await crypto.subtle.digest(algorithm, data)
	const hashArray = Array.from(new Uint8Array(hashBuffer))
	const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('')
	return hashHex
}
function updateTheme() {
	store.theme = store.theme === 'dark' ? 'light' : 'dark'
	emit('update:theme')
}
function cleanPayload(data) {
	const payload = Object.fromEntries(
		Object.entries({
			...data,
		}).filter(([_key, value]) => value)
	)

	return payload
}
async function copyHandler(tooltips, tooltipName, value) {
	try {
		const copied = await clipboard.copy(value)
		if (copied && !(copied instanceof Error)) {
			tooltips[tooltipName] = true
		}
	} finally {
		setTimeout(() => {
			tooltips[tooltipName] = false
		}, 1500)
	}
}

checkVersion()
versionCheckIntervalId.value = setInterval(checkVersion, 60000)

function setRefs(el, refs, refStrings) {
	refStrings.forEach(refString => {
		if (!refs.value[refString]) {
			refs.value[refString] = el
		}
	})

	return refs.value[refStrings[0]]
}
function formatPrice(amount) {
	return new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
	}).format(amount / 100)
}
function humanize(months, { brief = false } = {}) {
	// if months is equal to 12, return ' year'
	// if months is greater than 12 and evenly divisible by 12, return ' years'
	// if months is greater than 12, but not evenly divisible by 12, return ' months'
	// if months is less than 12, return ' month'

	if (months === 12) {
		return brief ? 'yr' : '1 year'
	} else if (months > 12 && months % 12 === 0) {
		return `${months / 12} years`
	} else if (months > 12) {
		return `${months} months`
	} else {
		return brief ? 'mo' : '1 month'
	}
}

onBeforeMount(() => {
	store.dashPlayers = {}
})

provide('humanize', humanize)
provide('formatPrice', formatPrice)
provide('setRefs', setRefs)
provide('copyHandler', copyHandler)
provide('cleanPayload', cleanPayload)
provide('hashString', hashString)
provide('cacheIsOld', cacheIsOld)
</script>
